import React from "react"
import Img from "gatsby-image"

export const CardWrapper: React.FC<{
  children: object
  className?: string
  flexRow?: Boolean
  rounded?: Boolean
}> = ({ children, className, flexRow = false, rounded = true }) => (
  <div
    className={[
      "bg-white border hover:shadow transition duration-100",
      !flexRow ? "flex flex-col" : "",
      rounded ? "site-border-radius" : "rounded",
      className,
    ].join(" ")}
  >
    {children}
  </div>
)

export const CardImage: React.FC<{ src: any }> = ({ src }) => {
  if (!src) {
    return (
      <div
        className="w-full bg-center bg-contain bg-no-repeat bg-white border-b bg-gray-300"
        title="No image"
        style={{
          borderTopRightRadius: "27px",
          borderTopLeftRadius: "27px",
          height: "240px",
          //backgroundImage: `url(${require('../../images/no-image-image.png')})`,
        }}
      />
    )
  }
  return (
    <Img
      className="w-full bg-center bg-cover bg-gray-400"
      style={{
        borderTopRightRadius: "27px",
        borderTopLeftRadius: "27px",
        height: "240px",
      }}
      fluid={src}
    />
  )
}

export const CardContentWrapper: React.FC<{ children: object }> = ({
  children,
}) => (
  <div className="text-site-blue-dark relative flex flex-1 flex-col p-4">
    {children}
  </div>
)
